import { render, staticRenderFns } from "./earnings.vue?vue&type=template&id=4ec2afe8&scoped=true"
import script from "./earnings.vue?vue&type=script&lang=js"
export * from "./earnings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec2afe8",
  null
  
)

export default component.exports